import { c as _c } from "react/compiler-runtime";
import type { ProfileActivityLog } from "@/entities/IProfile";
import { getTimeAgo } from "@/helpers/Helpers";
export default function ProfileActivityLogItemTimeAgo(t0) {
  const $ = _c(4);
  const {
    log
  } = t0;
  let t1;
  if ($[0] !== log.created_at) {
    t1 = getTimeAgo(new Date(log.created_at).getTime());
    $[0] = log.created_at;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const timeAgo = t1;
  let t2;
  if ($[2] !== timeAgo) {
    t2 = <span className="tw-whitespace-nowrap tw-font-normal tw-text-sm sm:tw-text-base tw-text-iron-500">{timeAgo}</span>;
    $[2] = timeAgo;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}